import "./ToolsGrid.scss";

const ToolsGrid = ({ dataList }) => {
  return (
    <section className="tools_sec p_top ">
      <div className="content_wrap p_bottom">
        <h2 className="wow fadeInUp">Tools</h2>
        <div className="tools_grid">
          {dataList?.map((data) => {
            return (
              <div className="tool_card wow fadeInUp" key={data?._id}>
                <h4>
                  <b>{data?.title}</b>
                </h4>
                <div
                  className="tool"
                  dangerouslySetInnerHTML={{ __html: data?.content }}
                ></div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ToolsGrid;
